import { SupportedCurrency } from "../utils/currency";

// frontend/src/types/index.ts
export interface User {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    isVerified: boolean;
    role: string;
    isPremium: boolean;
    premiumPlan?: string;
    premiumExpiresAt?: string;
    preferredCurrency?: string;
  }
  
  export interface AuthState {
    isAuthenticated: boolean;
    currentUser: User | null;
    loading: boolean;
    error: string | null;
  }
  export interface RegisterUserData {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    
  }
  export interface AuthContextType {
    isAuthenticated: boolean;
    loading: boolean;
    login: (email: string, password: string) => Promise<void>;
    register: (userData: RegisterUserData) => Promise<void>;
    logout: () => void;
    user: User | null; // Add this line to include the user property
  }
  
  export interface Couple {
    _id: string;
    names: string;
    weddingDate: string;
    weddingLocation?: string;
    weddingTheme?: string;
    story?: string;
    coverPhoto?: string;
    profilePhoto?: string;
    customUrl: string;
    couple: string | Couple;
    partners: string[];
    fundingGoal?: number;

  // Add the preferredCurrency property
  preferredCurrency?: string;
  // You might need these properties based on your component usage
  bridesName?: string;
  groomsName?: string;
    createdAt: string;
    updatedAt: string;
  }

  // Gift-related enums
export enum GiftStatus {
    AVAILABLE = 'available',
    RESERVED = 'reserved',
    PURCHASED = 'purchased',
  }
  
  // Contribution-related enums
  export enum ContributionType {
    GIFT = 'gift',
    WEDDING_FUND = 'wedding_fund',
    HONEYMOON = 'honeymoon',
    OTHER = 'other',
  }
  export enum RSVPStatus {
    ATTENDING = 'attending',
    NOT_ATTENDING = 'not_attending',
    PENDING = 'pending'
  }
  export interface CoupleState {
    couples: Couple[];
    currentCouple: Couple | null;
    loading: boolean;
    error: string | null;
  }
  
  export interface Gift {
    _id: string;
    name: string;
    description?: string;
    price?: number;
    image?: string;
    link?: string;
    status: 'available' | 'reserved' | 'purchased';
    couple: string;
    contributorName?: string;
    contributorEmail?: string;
    note?: string;
    category?: string;
    priority?: number;
    createdAt: string;
    updatedAt: string;
  }
  export interface RegistryItem {
    _id: string;
    name: string;
    description?: string;
    price: number;
    imageUrl?: string;
    status: GiftStatus;
    reservedBy?: {
      name: string;
      email: string;
      message?: string;
    };
    purchasedBy?: {
      name: string;
      email: string;
      message?: string;
    };
    couple: string;
    createdAt: string;
    updatedAt: string;
  }
  
  export interface Todo {
    _id: string;
    title: string;
    description?: string;
    dueDate?: string;
    completed: boolean;
    priority: 'low' | 'medium' | 'high';
    couple: string;
    assignedTo?: string;
    createdAt: string;
    updatedAt: string;
  }
  
  export interface Photo {
    _id: string;
    url: string;
    title?: string;
    caption?: string;
    featured: boolean;
    couple: string;
    uploaderName?: string;
    uploaderEmail?: string;
    createdAt: string;
    updatedAt: string;
  }
  
  export interface Event {
    _id: string;
    title: string;
    description?: string;
    date: string;
    time?: string;
    location?: string;
    address?: string;
    couple: string;
    createdAt: string;
    updatedAt: string;
  }
  
  export interface Contribution {
    _id: string;
    amount: number;
    contributorName: string;
    contributorEmail?: string;
    message?: string;
    type: 'gift' | 'wedding_fund' | 'honeymoon' | 'other';
    couple: string;
    paystackReference?: string;
    confirmed: boolean;
    currency: SupportedCurrency
    createdAt: string;
    updatedAt: string;
  }
  
  export interface ApiError {
    statusCode: number;
    message: string;
    error: string;
  }
  
  // Types for API responses
  export interface LoginResponse {
    accessToken: string;
    user: User;
  }
  
  export interface ContributionSummary {
    totalAmount: number;
    totalCount: number;
    currency?: string;
  }

export interface UploadResponse {
  url: {
    url: string;
  };
}

export interface Guest {
  _id: string;
  name: string; // Single field combining first and last name
  email?: string;
  phone?: string;
  rsvpStatus: RSVPStatus; // ATTENDING, NOT_ATTENDING, PENDING
  numberOfGuests: number;
  mealPreference?: string;
  message?: string;
  couple: string;
  createdAt: string;
  updatedAt: string;
}
  
  export interface MultiUploadResponse {
    urls: string[];
  }
  
  export interface DeleteResponse {
    deleted: boolean;
  }
  export enum TodoPriority {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high',
  }
  export interface RegisterResponse {
    user: User;
    accessToken: string;
    payment?: {
      reference: string;
      authorizationUrl: string;
    };
  }